export default __webpack_public_path__ + "static/media/thomas-eliot.5986d75a.jpg";